<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card>
      <v-toolbar color="#f9f9f9">
        <v-toolbar-title>保险条款</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="visible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="c-tk-dialog">
        <TK :code="code"></TK>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import TK from "@/components/Product/TK";
export default {
  components:{
    TK
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    code: String
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      }
    }
  }
};
</script>

<style lang="scss">
.c-tk-dialog {
  .tk-list {
    .tk-link {
      display: block;
      text-decoration: none;
      margin-bottom: 1em;
    }
  }
}
</style>

